// src/store/modules/authController.js
import axios from '@/api/axios'
import { MAIN_API } from '@/api/apiUrl'

export default {
    namespaced: true,
    state: {
    },
    mutations: {
    },
    actions: {
        async getCategoryList() {
            const response = await axios.get(`${MAIN_API}/api/category`, {
                headers: { 'Content-Type': 'application/json' }
            })
            return response.data
        },
        async createCategory(_, data) {
            const response = await axios.post(`${MAIN_API}/api/category/create`, data, {
                headers: { 'Content-Type': 'multipart/form-data' }
            })
            return response.data
        },
        async deleteCategory(_, id) {
            const response = await axios.delete(`${MAIN_API}/api/category/delete/${id}`, {
                headers: { 'Content-Type': 'application/json' }
            })
            return response.data
        },
        async updateCategory(_, data) {
            const response = await axios.put(`${MAIN_API}/api/category/update/${data.id}`, data, {
                headers: { 'Content-Type': 'application/json' }
            })
            return response.data
        },

    },
    getters: {
    }
}
